module.exports = __webpack_public_path__ + "static/media/assessment-end-screen-footer.db474721.png";